import type { ISiteService } from "./ISiteService";
import type { ApiSite, ApiReturnSite } from "@highimpact-frontend/api-types";
import { api_config } from "../../../api-commons";


class SiteService implements ISiteService {
    // get(): Promise<ApiReturnSite[]> {
    //     throw new Error("Method not implemented.");
    // }
    // get(id: number): Promise<ApiReturnSite> {
    //     throw new Error("Method not implemented.");
    // }
    async add(params: ApiSite): Promise<ApiReturnSite> {
        const response = await api_config.post('/sites', params);
        return response.data;
    }

    async update(id: number, params: ApiSite): Promise<ApiReturnSite> {
        const response = await api_config.put(`/sites/${id}`, params);
        return response.data;
    }

    async delete(id: number): Promise<ApiReturnSite> {
        const response = await api_config.delete(`/sites/${id}`);
        return response.data;
    }

}

const siteServiceInstance = new SiteService();
export default siteServiceInstance;